import { useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import { isEqual } from "lodash";
import { isNonEmptyArray, isObject } from "@cayuse/shared-react.utils.type-checks";

import { PRIVILEGES } from "globals/constants";
import { shellSelectors } from "store/selectors";


export const useHasPrivileges = privileges => {
	const { userPrivileges } = useSelector(shellSelectors.userAccess);
	const prev = useRef([null, null]);
	const result = useRef({});

	return useMemo(() => {
		if (isEqual(prev.current[0], privileges) && isEqual(prev.current[1], userPrivileges)) {
			return result.current;
		}

		const privilegeHash = {};

		if (isNonEmptyArray(privileges) && isObject(userPrivileges)) {
			privileges.forEach(privilege => {
				privilegeHash[privilege] = userPrivileges.some(priv => priv === privilege);
			});
			privilegeHash[PRIVILEGES.AWARD_NOTES_READ] = true;
			privilegeHash[PRIVILEGES.AWARD_NOTES_EDIT] = true;
		}
		privilegeHash[PRIVILEGES.AWARD_ATTACHMENTS_EDIT] = true;

		prev.current = [privileges, userPrivileges];
		result.current = privilegeHash;

		return result.current;
	}, [ privileges, userPrivileges ]);
};

export default useHasPrivileges;
